import React from 'react';
import { useAuthentication } from '../../contexts/AuthenticationContext';
import EmbeddedApiDocumentation from './EmbeddedApiDocumentation';
import ApiDocumentationDetail from './ApiDocumentationDetail';

const DocumentationsPage = () => {
    const { authInfo } = useAuthentication();
    return authInfo.useGitBookDocumentation ? <EmbeddedApiDocumentation /> : <ApiDocumentationDetail />;
};

export default DocumentationsPage;
